// export const URLFE = 'http://localhost:5002'; 
// export const URLSVC = 'http://localhost:5002/api'; 
// export const URL = URLSVC; 

export const URLFE = 'https://satudata.mubakab.go.id'; 
export const URLSVC = 'https://satudata.mubakab.go.id/api'; 
export const URL = URLSVC; 

//export const URL = 'http://localhost:5028';
//export const URLSVC = 'http://localhost:5028/api';
//export const URL = 'https://api.satudatamuba.swg.co.id';
//export const URLSVC = 'https://api.satudatamuba.swg.co.id/api';